import { DatasetSubtype, DatasetType } from 'src/app/modules/core/store/models/dataset.model';

export interface ExportTemplate {
  uId?: string | null;
  organizationUId?: string;
  datasetUId?: string;
  name?: string;
  description?: string;
  isValid?: boolean;
  ValidationMessage?: string;
  fileName?: string;
  type?: ExportTemplateType;
  createdOn?: string;
  updatedOn?: string;
  lastEditedByName?: string;
  lastEditedById?: string;
}

export enum ExportTemplateType {
  None = 0,
  Word = 1
}

export const DatasetTypesForDisplay: DatasetType[] = [
  DatasetType.ActivityLog,
  DatasetType.Alarm,
  DatasetType.Alerts,
  DatasetType.Assets,
  DatasetType.Camera,
  DatasetType.Geofence,
  DatasetType.PointOfInterest,
  DatasetType.Metrics,
  DatasetType.Picklist,
  DatasetType.ProfilePreferences,
  DatasetType.UserSubscriptions,
  DatasetType.SystemLog
];

export const SingleInstanceDatasetTypes: { type: DatasetType; subtype: DatasetSubtype }[] = [
  { type: DatasetType.UserSubscriptions, subtype: DatasetSubtype.None },
  { type: DatasetType.SystemLog, subtype: DatasetSubtype.MassNotification },
  { type: DatasetType.Assets, subtype: DatasetSubtype.HorizonPerson },
  { type: DatasetType.Default, subtype: DatasetSubtype.HorizonLocations },
  { type: DatasetType.Default, subtype: DatasetSubtype.HorizonAirlines },
  { type: DatasetType.Default, subtype: DatasetSubtype.HorizonCategory }
];

export const DatasetSubtypesForDisplay = {
  [DatasetType.Alerts]: [
    DatasetSubtype.None,
    DatasetSubtype.Intelligence,
    DatasetSubtype.Rating,
    DatasetSubtype.MobileEvent,
    DatasetSubtype.Earthquake,
    DatasetSubtype.Weather,
    DatasetSubtype.TropicalCyclone,
    DatasetSubtype.Wildfire,
    DatasetSubtype.Flight,
    DatasetSubtype.PowerOutageV2,
    DatasetSubtype.Vehicle,
    DatasetSubtype.HorizonLocationIntelRatings,
    DatasetSubtype.HorizonGeospatialThreatZone,
    DatasetSubtype.Tours,
    DatasetSubtype.SevenPAlert
  ],
  [DatasetType.Assets]: [
    DatasetSubtype.None,
    DatasetSubtype.Facility,
    DatasetSubtype.Person,
    DatasetSubtype.HorizonPerson,
    DatasetSubtype.Shipment,
    DatasetSubtype.Transports,
    DatasetSubtype.Device,
    DatasetSubtype.TravelItinerary,
    DatasetSubtype.Assignment,
    DatasetSubtype.Flight,
    DatasetSubtype.Vehicle,
    DatasetSubtype.Job,
    DatasetSubtype.Schedule,
    DatasetSubtype.Cardholder
  ],
  [DatasetType.PointOfInterest]: [DatasetSubtype.None, DatasetSubtype.Area, DatasetSubtype.Door],
  [DatasetType.Camera]: [DatasetSubtype.None, DatasetSubtype.Single, DatasetSubtype.Group, DatasetSubtype.Traffic, DatasetSubtype.AgentVmsIntegration, DatasetSubtype.Camera],
  [DatasetType.Alarm]: [DatasetSubtype.None],
  [DatasetType.Incident]: [DatasetSubtype.None],
  [DatasetType.Metrics]: [DatasetSubtype.None],
  [DatasetType.Geofence]: [DatasetSubtype.None],
  [DatasetType.ActivityLog]: [DatasetSubtype.None],
  [DatasetType.Picklist]: [DatasetSubtype.None],
  [DatasetType.SystemLog]: [DatasetSubtype.None, DatasetSubtype.MassNotification]
};

export interface DatasetAssetConfiguration {
  datasetName?: string;
  datasetUId?: string;
  geometryFieldName?: string;
  targetDistanceFieldName?: string;
}

export interface AlertTargetAssets {
  sourceFieldName?: string;
  targetDistanceFieldName?: string;
  assets?: DatasetAssetConfiguration[];
}

export interface DatasetShareSetting {
  organizationUId: string;
  datasetUId: string;
  datasetName: string;
  datasetShareUId: string;
  shareOrganizationUId: string;
  shareOrganizationName: string;
  isDeleted: boolean;
}

export interface AvailableSubscription {
  isPublicShared: boolean;
  isSharedWithAllConnectedOrgs: boolean;
  sharedWithOrgUId: string;
  sourceOrganizationUId: string;
  sourceOrganizationDisplayName: string;
  datasetUId: string;
  datasetName: string;
  type: DatasetType;
  subtype: DatasetSubtype;
  schema: string;
  defaultColor: string;
  opacity: number;
  iconPath: string;
  markerName: string;
  markerSize: string;
  customMarkerImage: string;
  customMarkerHeight: number;
  customMarkerWidth: number;
  isActive: boolean;
  isDeleted: boolean;
}

export interface DatasetUIdsByType {
  type: DatasetType;
  subtype: DatasetSubtype;
  uids: string[];
}
